import { render, staticRenderFns } from "./WarehouseDisplayView.vue?vue&type=template&id=fb20e154"
import script from "./WarehouseDisplayView.vue?vue&type=script&lang=js"
export * from "./WarehouseDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports